import React, { ReactElement, useRef } from "react";
import ReactDOM from "react-dom";

type ZeeroPopupProps = {
	show?: boolean;
	onClose?: (evt: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
	className?: string;
	children?: React.ReactNode;
};

export function ZeeroPopup({show = true, onClose, className, children}: ZeeroPopupProps): ReactElement | null {
	const popupRef = useRef<HTMLDivElement>(null);

	if (!show) return <React.Fragment></React.Fragment>;

	return (
		<React.Fragment>
			{ReactDOM.createPortal(
				<div
					id="popup-wrapper"
					className={`${show ? "show" : ""}`}
					onClick={(evt) => {
						if (
							popupRef.current &&
							onClose &&
							!popupRef.current.contains(evt.target as HTMLElement)
						) {
							onClose(evt);
						}
					}}
				>
					<div id="popup" ref={popupRef} className={className}>
						{children}
					</div>
				</div>,
				document.getElementById("zeero-popups-root")!
			)}
		</React.Fragment>
	);
}

export function Content(props: ZeeroPopupProps): ReactElement {
	return <div id="popup-content">{props.children}</div>;
}

export function Prefix(props: ZeeroPopupProps): ReactElement {
	return <div className="popup-appendix prefix">{props.children}</div>;
}

export function Suffix(props: ZeeroPopupProps): ReactElement {
	return <div className="popup-appendix suffix">{props.children}</div>;
}

export function Body(props: ZeeroPopupProps): ReactElement {
	return (
		<div id="popup-body" draggable={false}>
			{props.children}
		</div>
	);
}

export function Title(props: ZeeroPopupProps): ReactElement {
	return (
		<div id="popup-title-container">
			<div id="popup-title">{props.children}</div>
			{props.onClose && (
				<div id="popup-close" onClick={props.onClose}>
					<div className="fa fa-solid fa-xmark"></div>
				</div>
			)}
		</div>
	);
}

export function Footer(props: ZeeroPopupProps): ReactElement {
	return <div id="popup-footer">{props.children}</div>;
}
